import { Box, List } from "@mui/material";
import SideMenuButton from "./SideMenuButton";
import { VFC } from "react";
import { ApplicationProtectedRouting } from "../../Routing";

type Props = {
  selectBtnIndex: number; // 選択中のボタン番号
  width?: string; // Boxのwidth属性の値
  buttonHeight?: number | string;
};

const SideMenu: VFC<Props> = ({ selectBtnIndex, width = "200px", buttonHeight = "100px" }) => {
  return (
    <Box
      component={"aside"}
      position={"fixed"}
      bgcolor={"#f5f5f5"}
      height={"100vh"}
      width={width}
      overflow={"auto"}
      zIndex={"10"}
    >
      <List>
        <SideMenuButton 
            buttonName='テナント管理' 
            linkPage={ApplicationProtectedRouting.tenant.path()} 
            index={0} 
            isSelected={selectBtnIndex===0}
            height={buttonHeight}
        />
        <SideMenuButton 
            buttonName='契約管理' 
            linkPage={ApplicationProtectedRouting.contract.path()} 
            index={1} 
            isSelected={selectBtnIndex===1}
            height={buttonHeight}
        />
        <SideMenuButton 
            buttonName='端末管理' 
            linkPage={ApplicationProtectedRouting.terminal.path()} 
            index={2} 
            isSelected={selectBtnIndex===2}
            height={buttonHeight}
        />
        <SideMenuButton 
            buttonName='アカウント　管理' 
            linkPage={ApplicationProtectedRouting.mdmUser.path()} 
            index={3} 
            isSelected={selectBtnIndex===3}
            height={buttonHeight}
        />
        {/** 未実装 */}
        {/* <SideMenuButton 
            buttonName='デバイス利用状況' 
            linkPage={ApplicationProtectedRouting.device.path()} 
            index={2} 
            isSelected={selectBtnIndex===2}
        />
        <SideMenuButton 
            buttonName='Web利用状況' 
            linkPage={ApplicationProtectedRouting.web.path()} 
            index={3} 
            isSelected={selectBtnIndex===3}
        /> */}
        
      </List>
    </Box>
  );
};

export default SideMenu;
